import { create } from 'zustand'

export interface State {
  ready: boolean
  loaded: boolean
  error: string | null
  /**
   * When `Controller.refresh` last finished, in ms. The graph checks its drawing on each new value
   * (app#349): a refresh after a wake is the moment a reader looks at it again. 0 = never.
   */
  refreshedAt: number
}

const useApp = create<State>()(() => ({
  ready: false,
  loaded: false,
  error: null,
  refreshedAt: 0,
}))

export default useApp
